import __request__ from "routing/request";
export function forParameter(requestOptions) {
  return __request__("POST", "/views/forValue", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
